import { FC } from 'react';
import { useTranslation } from 'react-i18next';

import { Divider } from '@mui/material';

import WaveUIAccordion from '@/shared/components/widgets/WaveUIAccordion';
import { AppPath } from '@/shared/constants/path';
import Payment from '@/shared/types/order/payment.type';
import formatCurrency from '@/shared/utils/formatCurrency';

import GatewayDetail from './components/GatewayDetail';
import PaymentBreakdownInfo from './components/PaymentBreakdownInfo';
import Title from './components/Title';

const getPaymentBreakdownTotal = (payment: Payment) => {
  // TODO: replace temporary stub variables with actual calculation
  const tax = '0';
  const shipping = '0';
  const discount = '0';

  const calculation =
    parseFloat(payment.transaction_amount) +
    parseFloat(tax) +
    parseFloat(shipping) -
    parseFloat(discount);

  return formatCurrency(calculation);
};

type PaymentDetailsPanelProps = {
  payment: Payment;
};

const PaymentDetailsPanel: FC<PaymentDetailsPanelProps> = ({ payment }) => {
  const { t } = useTranslation(['payments', 'common']);

  return (
    <WaveUIAccordion defaultExpanded title={t('payments:gatewayDetails')}>
      <Title
        status={payment.status}
        transactionId={payment.in_transaction_id}
        transactionType={payment.transaction_type}
        transactionCreated={payment.ts_created}
      />

      <GatewayDetail
        title={t('payments:amount')}
        details={[
          {
            label: formatCurrency(parseFloat(payment.transaction_amount)),
          },
        ]}
      />

      <GatewayDetail
        title={t('payments:orderId')}
        details={[
          {
            label: payment.in_order_id.split('-')[0],
            to: AppPath.Orders + '/' + payment.in_order_id,
          },
        ]}
      />

      <Divider />

      <PaymentBreakdownInfo
        title={t('payments:paymentBreakdown')}
        details={[
          {
            label: t('payments:subtotal'),
            amount: formatCurrency(parseFloat(payment.transaction_amount)),
          },
          {
            label: t('payments:tax'),
            amount: formatCurrency(parseFloat('0')), // TODO: replace with actual tax amount
          },
          {
            label: t('payments:shipping'),
            amount: formatCurrency(parseFloat('0')), // TODO: replace with actual shipping amount
          },
          {
            label: t('payments:total'),
            amount: getPaymentBreakdownTotal(payment),
            highlight: true,
          },
        ]}
      />
    </WaveUIAccordion>
  );
};

export default PaymentDetailsPanel;
